export const toggleNav = () => ({
  type: 'TOGGLE_NAV'
});

export const closeNav = () => ({
  type: 'CLOSE_NAV'
});

export const setInvertedTheme = () => ({
  type: 'SET_THEME_INVERTED'
});

export const unsetInvertedTheme = () => ({
  type: 'UNSET_THEME_INVERTED'
});

export const setIsOnWhitePage = () => ({
  type: 'SET_IS_ON_WHITE_PAGE'
});

export const unsetIsOnWhitePage = () => ({
  type: 'UNSET_IS_ON_WHITE_PAGE'
});



// WEBPACK FOOTER //
// ./src/actions/ui.js